export default function urlOrigin() {
  const origin=window.location.origin;
  if(origin.match(/:/g).length > 1) {
    const cortado=origin.slice(0,-5);
    return `${cortado}:9000/api/v1`
  }
  return `${origin}/api/v1`;
}
